import { Component, Vue } from 'vue-property-decorator';
import * as constants from './constants';
import Form from '@/components/Form/Form';
import {TOAST_OPTIONS} from '@/utils/sharedOptions';
import VueToast from 'vue-toasted';
import { uploadSettingsNetwork as uploadSettingsNetworkFn } from '@/utils/api';
import InputField from '@/types/InputField';

Vue.use(VueToast, TOAST_OPTIONS);

@Component({
    components: {
        Form,
    },
})

export default class UploadSettingsNetworkForm extends Vue {
    public constants: object = constants;
    public uploadSettingsNetworkError: null | string = null;
    public uploadSettingsNetworkFields: InputField[] = [
        {
            updateInput: this.updateSettingsNetworkInput,
            type: 'file',
            key: constants.UPLOAD_SETTINGS_NETWORK_KEY,
            accept: '.xlsx',
        },
    ];

    private file: File | null = null;

    public updateSettingsNetworkInput(input: File | null): void {
        this.file = input;
    }

    public async uploadSettingsNetwork(): Promise<void> {
        this.uploadSettingsNetworkError = null;
        try {
            await uploadSettingsNetworkFn(this.file);
            this.$toasted.show(constants.UPLOAD_SETTINGS_NETWORK_SUCCESSFULLY, TOAST_OPTIONS);
        } catch (error) {
            this.uploadSettingsNetworkError = error.message;
        }
    }
}
